/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetEntityOfficer = require('../services/GetEntityOfficer');

var DepOfficerDashboardView = require('../views/DepOfficerDashboardView');

module.exports = function(entityId, officerId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetEntityIdentifiers(entityId), GetEntityOfficer(officerId)).done(function(entityIdentifiers, officer) {
    NavUtils.navigate('dep/entity/' + entityId + '/officer/' + officerId + '/dashboard');
    Scaffold.content.show(
      new DepOfficerDashboardView({
        model: new Backbone.Model({
          entityIdentifiers: entityIdentifiers,
          officer: officer
        })
      })
    );
    NProgress.done();
  });
};
